import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["checkbox"]
  static values = {
    projectId: String,
    url: String,
    currentFeaturedIndex: Number
  }

  connect() {
    console.log("Featured image controller connected")
    this.currentFeaturedIndexValue = this.checkboxTargets.find(cb => cb.checked)?.dataset.imageIndex || null
  }

  toggle(event) {
    const selectedRadio = event.target
    const imageIndex = selectedRadio.dataset.imageIndex

    // Check if this image is hidden
    const checkbox = this.element.querySelector(`input[type="checkbox"][data-image-index="${imageIndex}"]`)
    if (checkbox && checkbox.checked) {
      alert("Cannot feature a hidden image")
      // Revert to previous featured image
      if (this.currentFeaturedIndexValue !== null) {
        const prevRadio = this.checkboxTargets.find(cb => cb.dataset.imageIndex == this.currentFeaturedIndexValue)
        if (prevRadio) prevRadio.checked = true
      } else {
        selectedRadio.checked = false
      }
      return
    }

    // Radio buttons handle mutual exclusivity natively
    // Just send the AJAX request to update featured image
    this.currentFeaturedIndexValue = imageIndex
    this.updateFeaturedImage(imageIndex)
  }

  updateFeaturedImage(imageIndex) {
    const url = `/campus/student_projects/${this.projectIdValue}/set_featured_image`
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken,
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        image_index: imageIndex
      })
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          console.log('Featured image updated successfully')
          // Optionally show a success message
        } else {
          console.error('Failed to update featured image:', data.error)
          alert('Failed to update featured image: ' + (data.error || 'Unknown error'))
          // Revert checkbox state on error
          this.revertCheckboxes()
        }
      })
      .catch(error => {
        console.error('Error updating featured image:', error)
        alert('An error occurred while updating the featured image')
        // Revert checkbox state on error
        this.revertCheckboxes()
      })
  }

  revertCheckboxes() {
    // This would need to restore the previous state
    // For now, just reload the page or refetch the data
    location.reload()
  }
}
